import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import Editor from 'react-simple-wysiwyg'
import { Button } from '../../../../components/ui/button'
import { Form, FormControl, FormField, FormItem, FormMessage } from '../../../../components/ui/form'
import { Input } from '../../../../components/ui/input'
import { TemplateFormData, templateSchema } from '../../../../validators/template-validator'
import { createTemplate } from '../actions'
import { loadTemplate } from '../actions/load-templates'
import { updateTemplate } from '../actions/update-template'

interface FormTemplateProps {
  templateId: string | null
}

export function FormTemplate({ templateId }: FormTemplateProps) {
  const form = useForm<TemplateFormData>({
    resolver: zodResolver(templateSchema),
    defaultValues: {}
  })

  const onSubmit = async (data: TemplateFormData) => {
    if (templateId) {
      await updateTemplate(data)
      form.reset()
      form.setValue('nome', '')
      return
    }

    await createTemplate(data)
    form.reset()
    form.setValue('nome', '')
  }

  useEffect(() => {
    if (templateId) {
      loadTemplate(templateId).then((response) => {
        const template = response.data.data
        console.debug({ template })
        form.setValue('unidade.id', String(template?.unidade.id))
        form.setValue('nome', template?.nome)
        form.setValue('conteudo', template?.conteudo)
        form.setValue('id', Number(template?.id))
        form.setValue('inclusao', template?.inclusao)
      })
    }
  }, [templateId])

  return (
    <Form {...form}>
      <form className="content mt-6  flex flex-col gap-4" onSubmit={form.handleSubmit(onSubmit)}>
        <FormField
          control={form.control}
          name="nome"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input placeholder="Nome do template" {...field} />
              </FormControl>
              <FormMessage className="text-xs">{form.formState.errors.nome?.message}</FormMessage>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="conteudo"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Editor
                  value={field.value}
                  onChange={(e) => field.onChange(e.target.value)}
                  className="h-container-contract overflow-y-auto "
                  containerProps={{
                    style: {
                      overflowY: 'auto'
                    }
                  }}
                />
              </FormControl>
              <FormMessage className="text-xs">{form.formState.errors.conteudo?.message}</FormMessage>
            </FormItem>
          )}
        />

        <div className="">
          <Button type="submit" className="text-muted font-bold flex gap-2 text-sm bg-acelerafit-green-400 hover:bg-acelerafit-green-300">
            {templateId ? 'Atualizar template' : 'Cadastrar template'}
          </Button>
        </div>
      </form>
    </Form>
  )
}
